import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-index-digital-agency',
  templateUrl: './index-digital-agency.component.html',
  styleUrls: ['./index-digital-agency.component.css']
})

/**
 * Digital Agency Component
 */
export class IndexDigitalAgencyComponent implements OnInit {

  // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true
  /**
   * Footer bg color set
   */
  footerClass: true;
  footerVariant = 'bg-light';

  constructor(private modalService: NgbModal) { }

  /**
   * Testimonial Slider
   */
  customOptions: OwlOptions = {
    // loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      900: {
        items: 1
      }
    },
    nav: false
  };

  ngOnInit(): void {
  }

  /**
    * Open modal for show the video
    * @param content content of modal
    */
  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }
  openWindowmModal(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }

}
